const currentUrl = window.location.protocol + '//' + window.location.host + window.location.pathname
const searchParams = new URLSearchParams(document.location.search)
export const initialChoosedOptionsContext = {
    registrationName: searchParams.get('registrationName') ?? '',
    registrationNameFirst: searchParams.get('registrationNameFirst') ?? '',
    registrationNameSecond: searchParams.get('registrationNameSecond') ??  '',
    typeOfTransport: searchParams.get('typeOfTransport') ?? 'car',
    categoryPlate: searchParams.get('categoryPlate') ?? 'standard',
    frontId:  searchParams.get('frontId') ?? 'null',
    rearId:  searchParams.get('rearId') ?? 'null',
    showBSAU: searchParams.get('showBSAU') ?? 'true',
    designRequired: searchParams.get('designRequired') ?? 'false',
    breakLine: searchParams.get('breakLine') ?? 'false',
    designText: searchParams.get('designText') ?? '',
    frontPlate: searchParams.get('frontPlate') ?? 'true',
    rearPlate: searchParams.get('rearPlate') ?? 'true',
    plateSizeFront: searchParams.get('plateSizeFront') ?? 'Standard Car Oblong (20.5x4.4in)',
    plateSizeRear: searchParams.get('plateSizeRear') ?? 'Standard Car Oblong (20.5x4.4in)',
    plateMaterial : searchParams.get('plateMaterial') ?? 'null' ,
    fontStyle: searchParams.get('fontStyle') ?? 'null',
    fontColor: searchParams.get('fontColor') ?? 'black',
    borderWidth: searchParams.get('borderWidth') ?? 'null',
    borderColor: searchParams.get('borderColor') ?? 'black',
    price: searchParams.get('price') ?? '19.98',
    materialPrice: searchParams.get('materialPrice') ?? '9.99',
    fontPrice: searchParams.get('fontPrice') ?? '0',
    frontPrice: searchParams.get('frontPrice') ?? '9.99',
    rearPrice: searchParams.get('rearPrice') ?? '9.99',
    sloganName: searchParams.get('sloganName') ?? 'Great Plates, JE2 3RD',
    sloganFont: searchParams.get('sloganFont') ?? '6px',
    sloganStyle: searchParams.get('sloganStyle') ?? 'Open Sans',
    sloganColor: searchParams.get('sloganColor') ?? 'black',
    fullHeightBadge: searchParams.get('fullHeightBadge') ?? 'false',
    badgeLeft: searchParams.get('badgeLeft') ?? 'null',
    badgeColorLeft: searchParams.get('badgeColorLeft') ?? 'null',
    badgeRight: searchParams.get('badgeRight') ?? 'null',
    badgeColorRight: searchParams.get('badgeColorRight') ?? 'null',
    badgeLeftName: searchParams.get('badgeLeftName') ?? 'null',
    badgeRightName: searchParams.get('badgeRightName') ?? 'null',
    badgeInsideBorder: searchParams.get('badgeInsideBorder') ?? 'true',
    frontPlateImg: '',
    rearPlateImg: '',
    hasCustomBadgeLeft: searchParams.get('hasCustomBadgeLeft') ?? 'false',
    hasCustomBadgeRight: searchParams.get('hasCustomBadgeRight') ?? 'false',
    customBadgeLeft: null,
    customBadgeRight: null,
    customBadgeImageLeft: searchParams.get('customBadgeImageLeft') ?? 'null',
    customBadgeImageRight: searchParams.get('customBadgeImageRight') ?? 'null',
    customBadgeTextLeft: searchParams.get('customBadgeTextLeft') ?? '',
    customBadgeIconColorLeft: searchParams.get('customBadgeIconColorLeft') ?? '',
    customBadgeIconColorRight: searchParams.get('customBadgeIconColorRight') ?? '',
    customBadgeColorizeLeft: searchParams.get('customBadgeColorizeLeft') ?? 'false',
    customBadgeColorizeRight: searchParams.get('customBadgeColorizeRight') ?? 'false',
    customBadgeTextRight: searchParams.get('customBadgeTextRight') ?? '',
    customBadgeFontLeft: searchParams.get('customBadgeFontLeft') ?? 'CharlesWright Bold',
    customBadgeFontRight: searchParams.get('customBadgeFontRight') ?? 'CharlesWright Bold',
    customBadgeTextColorLeft: searchParams.get('customBadgeTextColorLeft') ?? 'null',
    customBadgeTextColorRight: searchParams.get('customBadgeTextColorRight') ?? 'null',
    customBadgeRotationLeft: searchParams.get('customBadgeRotationLeft') ?? 'false',
    customBadgeRotationRight: searchParams.get('customBadgeRotationRight') ?? 'false',
}

window.history.replaceState('', '', currentUrl + '?' + searchParams.toString())